import { IonButton } from '@ionic/react';

export const ClearFilter = ({onClick}) => (
  <IonButton
    onClick={() => onClick()}
    color='fern'
    fill='outline'
    size='small'
  >
    Clear
  </IonButton>
);
